import { keyframes } from "@emotion/react";
import styled from "@emotion/styled";
import { rem } from "polished";

import { animationDurationCSS, curves } from "../../design-tokens/animations";
import { colors } from "../../design-tokens/colors";
import { globalContentMaxWidth, sizes } from "../../design-tokens/dimensions";
import { borderRadii } from "../../design-tokens/effects";

const progressPulseWidth = sizes.s48.rem;

const flow = keyframes`
  0% {
    left: -${progressPulseWidth};
  }
  100% {
    left: 100%;
  }
`;

export const Root = styled.div`
  display: flex;
  height: ${sizes.s8.rem};
  max-width: ${rem(globalContentMaxWidth)};
  overflow: hidden;
  position: relative;
  width: 100%;
`;

// It is not possible to reliably animate the value bar in a progress element. As such positioning this over the top gives us that option.
export const AnimationBar = styled.div<{ $isIndeterminate: boolean }>`
  --gradientWidth: ${progressPulseWidth};
  border-radius: ${borderRadii.r8};
  height: 100%;
  left: 0;
  overflow: hidden;
  pointer-events: none;
  position: absolute;
  top: 0;
  width: calc(var(--valueWidth) * 1%);

  @media (prefers-reduced-motion: reduce) {
    display: none;
  }

  &::after {
    animation: ${flow} ${animationDurationCSS(3)} infinite ${curves.linear};
    background: ${({ $isIndeterminate }) =>
        $isIndeterminate
          ? colors.blue
          : `linear-gradient(to left, transparent, ${colors.blueLight}, transparent)`}
      no-repeat;
    content: "";
    height: 100%;
    left: 0;
    position: absolute;
    width: ${sizes.s48.rem};
  }
`;

export const ProgressBar = styled.progress`
  appearance: none;
  background-color: ${colors.baseDark};
  border-radius: ${borderRadii.r8};
  height: 100%;
  margin: 0 auto;
  overflow: hidden;
  width: 100%;

  &[value]::-webkit-progress-value {
    background: ${colors.blue};
    position: relative;
  }
`;
